const LAST_VISITED_KEY = 'newron_last_visited';

function set(url: string): void {
  localStorage.setItem(LAST_VISITED_KEY, url);
}

function get(): string | undefined {
  return localStorage.getItem(LAST_VISITED_KEY);
}

export const lastVisited = {
  get,
  set,
};
